<template>
  <div>
    <div
      v-if="apiKey"
      class="text-gray-700 mx-auto max-w-xl relative"
      style="padding-top: 20vh; z-index: 10"
    >
      <a
        class="pb-3 border-gray-300 pt-4 text-gray-900 border-b flex items-center space-x-2"
        href="/platform"
      >
        <div class="font-bold tracking-tighter">Campflare</div>
      </a>
      <div class="text-4xl tracking-tight mt-6">
        Welcome to the Campflare Platform
      </div>
      <div class="text-lg text-gray-700">
        Your API Key has been Created Successfully
      </div>
      <div class="mt-8">
        <div class="pb-1.5 mt-4">Your API Key</div>
        <c class="block text-xl px-5 py-3 overflow-x-scroll">{{ apiKey }}</c>
      </div>
      <div class="text-lg mt-6 text-gray-700">
        <b class="text-green-600"
          >Save your API Key somewhere safe. You won't be able to view it
          again.</b
        >
        However, you can always regenerate the key on your account page.
      </div>
      <a
        class="block text-center bg-primary py-4 rounded-md font-semibold text-white cursor-pointer hover:bg-primary-dark mt-8"
        href="/platform"
      >
        Get Started
      </a>
    </div>
    <div
      v-else
      class="text-gray-700 mx-auto max-w-md relative"
      style="padding-top: 20vh; z-index: 10"
    >
      <div v-if="!apiKey">
        <a
          class="mb-2 text-sm text-gray-600 hover:text-gray-900 cursor-pointer"
          href="/"
          v-if="!lookingForCode"
        >
          Back
        </a>
        <a
          v-else
          class="mb-2 text-sm text-gray-600 hover:text-gray-900 cursor-pointer"
          @click="
            lookingForCode = false;
            codeError = '';
          "
        >
          Back
        </a>
      </div>

      <a
        class="pb-3 border-gray-300 pt-4 text-gray-900 border-b flex items-center space-x-2"
        href="/platform"
      >
        <div class="font-bold tracking-tighter">Campflare</div>
      </a>
      <div v-if="lookingForCode" class="flex flex-col mt-4">
        <div class="text-gray-700">
          A 6-digit code has been sent to <b>{{ email }}</b
          >, type in the code here to finish.
        </div>
        <label class="pb-1.5 mt-4"> Email Code </label>
        <input
          v-model="code"
          class="focus:border-gray-400 flex-1 outline-none border w-100 rounded-md px-4 py-2 bg-white border-1 border-gray-300 mb-4"
          placeholder="6 digits"
        />
        <div v-if="codeError" class="text-sm text-red-600">
          *{{ codeError }}
        </div>
        <div v-else class="h-0.5"></div>
        <div
          class="flex-1 text-center bg-primary py-4 rounded-md font-semibold text-white cursor-pointer hover:bg-primary-dark mt-4"
          @click="checkCode"
        >
          Check Code
        </div>
      </div>
      <div v-else>
        <div class="mt-4 mb-4">
          <div class="flex space-x-6" v-if="!login">
            <div class="flex flex-col space-y-1 flex-1">
              <label> First Name </label>
              <input
                v-model="first"
                :class="`focus:border-gray-400 flex-1 outline-none border w-100 rounded-md px-4 py-2 bg-white border-1 border-gray-300`"
                placeholder="First"
                type="text"
              />
            </div>
            <div class="flex flex-col space-y-1 flex-1">
              <label> Last Name </label>
              <input
                v-model="last"
                :class="`focus:border-gray-400 flex-1 outline-none border w-100 rounded-md px-4 py-2 bg-white border-1 border-gray-300`"
                placeholder="Last"
                type="text"
              />
            </div>
          </div>
          <div class="flex flex-col space-y-1 mt-5 mb-5" v-if="!login">
            <label> Company </label>
            <input
              v-model="company"
              :class="`focus:border-gray-400 flex-1 outline-none border w-100 rounded-md px-4 py-2 bg-white border-1 border-gray-300`"
              placeholder="Company (optional)"
              type="text"
            />
          </div>
          <div class="flex flex-col space-y-1 mt-5">
            <label> Your Email </label>
            <input
              v-model="email"
              :class="`focus:border-gray-400 flex-1 outline-none border w-100 rounded-md px-4 py-2 bg-white border-1 border-gray-300`"
              placeholder="Email"
              type="email"
            />
          </div>
        </div>
        <div v-if="error" class="text-sm text-red-600">*{{ error }}</div>
        <div v-else class="h-0.5"></div>
        <div
          class="text-center bg-primary py-4 rounded-md font-semibold text-white cursor-pointer hover:bg-primary-dark mt-4"
          @click="tryLogin"
        >
          {{ login ? "Log in" : "Sign up" }}
        </div>
        <div class="text-gray-600 text-sm text-center mt-2">
          By signing up, you agree to the
          <a href="/api-agreement.pdf" class="underline" target="_blank"
            >Campflare API Access Agreement</a
          >
        </div>

        <div
          class="text-center pt-1 mt-2.5 cursor-pointer hover:opacity-60"
          @click="
            login = !login;
            error = '';
          "
        >
          <div v-if="login">
            Don't have an account?
            <span class="text-primary pl-1">Sign up</span>
          </div>
          <div v-else>
            Already have an account?
            <span class="text-primary pl-1">Sign in</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { sendCodeToLogin, checkCodeAndLogin } from "@/api";

export default {
  name: "LoginOrSignup",
  data: () => {
    return {
      code: "",
      email: "",
      first: "",
      last: "",
      company: "",
      error: "",
      codeError: "",
      apiKey: "",
      lookingForCode: false,
      login: false,
    };
  },
  computed: {
    emailIsValid() {
      return this.email.includes("@");
    },
  },
  mounted() {},
  methods: {
    async tryLogin() {
      this.error = this.refreshError();

      if (this.error) {
        return;
      }

      await sendCodeToLogin({
        email: this.email,
        company: this.company,
        first: this.first,
        last: this.last,
      });

      this.lookingForCode = true;
    },
    async checkCode() {
      try {
        const apiKey = await checkCodeAndLogin(this.email, this.code);

        if (apiKey) {
          this.apiKey = apiKey;
        }
      } catch {
        this.codeError = "Invalid code, please try again";
      }
    },
    refreshError() {
      if (!this.login) {
        if (!this.first) {
          return "Please enter your first name";
        }

        if (!this.last) {
          return "Please enter your last name";
        }
      }

      if (!this.email) {
        return "Please enter your email";
      }

      const tester = new RegExp(/^\S+@\S+\.\S+$/);
      if (!tester.test(this.email)) {
        return "Please a valid email";
      }

      return "";
    },
  },
};
</script>
